const blocks = [
  {
    name: "Page",
    displayName: "Page",
    type: "page",
    image: "",
    props: [
      {
        name: "backgroundColor",
        displayName: "backgroundColor",
        editor: "color",
        editorParams: { default: "#fff", styleName: true },
        help: "",
      },
      {
        name: "alignItems",
        displayName: "Horizontal Alignment",
        editor: "alignItems",
        editorParams: { default: "stretch" },
        help: "",
      },
    ],
    events: [],
  },
  {
    name: "Component",
    displayName: "Component",
    type: "page",
    image: "",
    props: [
      {
        name: "type",
        displayName: "Container Type",
        editor: "dropdown",
        editorParams: {
          default: "relative",
          options: [
            { value: "relative", text: "Row" },
            { value: "absolute", text: "Floating" },
          ],
        },
        help: "Container Type",
      },
      {
        name: "backgroundColor",
        displayName: "backgroundColor",
        editor: "color",
        editorParams: { default: "#fff", styleName: true },
        help: "",
      },
      {
        name: "justifyContent",
        displayName: "Horizontal Alignment",
        editor: "justifyContent",
        editorParams: { default: "flex-start" },
        help: "",
      },
      {
        name: "size",
        displayName: "Sizing",
        editor: "size",
        editorParams: {
          default: { minWidth: 40, maxWidth: "", minHeight: 40, maxHeight: "" },
          styleName: true,
        },
        help: "",
      },
      {
        name: "flexGrow",
        displayName: "Flex Grow",
        editor: "flexGrow",
        editorParams: { default: 0 },
        help:
          "This is how large this element should be relative to the other elements in the same column of row",
      },
    ],
    events: [
      {
        name: "onLoad",
        displayName: "This component is loaded",
        params: [],
      },
    ],
  },
  {
    name: "Row",
    displayName: "Row",
    type: "container",
    id: "Row",
    image:
      "https://storage.googleapis.com/deft-cef16.appspot.com/icons/Frame%208.svg",
    props: [
      {
        name: "backgroundColor",
        displayName: "Background Color",
        editor: "color",
        editorParams: {
          default: "#fff",
          styleName: "backgroundColor",
        },
        help: "Background Color of this Row",
      },
      {
        name: "border",
        displayName: "Border",
        editor: "border",
        editorParams: {
          default: {
            borderTop: "0px solid #333",
            borderRight: "0px solid #333",
            borderLeft: "0px solid #333",
            borderBottom: "0px solid #333",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
          },
          styleName: true,
        },
        help: "",
      },
      {
        name: "boxShadow",
        displayName: "Shadow",
        editor: "shadow",
        editorParams: {
          default: "0px 0px 0px 0px rgba(0,0,0,0)",
          styleName: "boxShadow",
        },
        help: "",
      },

      {
        name: "size",
        displayName: "Sizing",
        editor: "size",
        editorParams: {
          default: { minWidth: 40, maxWidth: "", minHeight: 40, maxHeight: "" },
          styleName: true,
        },
        help: "",
      },

      {
        name: "justifyContent",
        displayName: "Horizontal Alignment",
        editor: "justifyContent",
        editorParams: { default: "flex-start", styleName: true },
        help: "",
      },
      {
        name: "alignItems",
        displayName: "Vertical Alignment",
        editor: "alignItems",
        editorParams: { default: "flex-start", styleName: true },
        help: "",
      },
      {
        name: "flexGrow",
        displayName: "Flex Grow",
        editor: "flexGrow",
        editorParams: { default: 0, styleName: true },
        help:
          "This is how large this element should be relative to the other elements in the same column of row",
      },
      {
        name: "spacing",
        displayName: "Spacing",
        editor: "spacing",
        editorParams: {
          default: {
            marginTop: 0,
            marginRight: 0,
            marginLeft: 0,
            marginBottom: 0,
            paddingTop: 0,
            paddingRight: 0,
            paddingLeft: 0,
            paddingBottom: 0,
          },
          styleName: true,
        },
        help: "",
      },
    ],
    events: [
      {
        name: "onClick",
        displayName: "This Row is clicked",
        params: [],
      },
    ],
    cssStates: ["hover"],
  },
  {
    name: "Popup",
    displayName: "Popup",
    type: "overlay",
    id: "Popup",
    image:
      "https://storage.googleapis.com/deft-cef16.appspot.com/icons/Frame%2013.svg",
    props: [
      {
        name: "overlay",
        displayName: "Overlay Color",
        editor: "color",
        editorParams: {
          default: "rgba(0,0,0,.6)",
        },
        help: "",
      },
      {
        name: "backgroundColor",
        displayName: "Background Color",
        editor: "color",
        editorParams: {
          default: "#fff",
          styleName: "backgroundColor",
        },
        help: "Background Color of this Row",
      },

      {
        name: "border",
        displayName: "Border",
        editor: "border",
        editorParams: {
          default: {
            borderTop: "0px solid #333",
            borderRight: "0px solid #333",
            borderLeft: "0px solid #333",
            borderBottom: "0px solid #333",
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
            borderBottomLeftRadius: 10,
            borderBottomRightRadius: 10,
          },
          styleName: true,
        },
        help: "",
      },
      {
        name: "boxShadow",
        displayName: "Shadow",
        editor: "shadow",
        editorParams: {
          default: "0px 0px 0px 0px rgba(0,0,0,0)",
          styleName: "boxShadow",
        },
        help: "",
      },

      {
        name: "size",
        displayName: "Sizing",
        editor: "size",
        editorParams: {
          default: {
            minWidth: 40,
            maxWidth: 400,
            minHeight: 200,
            maxHeight: 400,
          },
          styleName: true,
        },
        help: "",
      },

      {
        name: "justifyContent",
        displayName: "Horizontal Alignment",
        editor: "justifyContent",
        editorParams: { default: "flex-start", styleName: true },
        help: "",
      },
      {
        name: "alignItems",
        displayName: "Vertical Alignment",
        editor: "alignItems",
        editorParams: { default: "flex-start", styleName: true },
        help: "",
      },
      {
        name: "flexGrow",
        displayName: "Flex Grow",
        editor: "flexGrow",
        editorParams: { default: 0, styleName: true },
        help:
          "This is how large this element should be relative to the other elements in the same column of row",
      },
      {
        name: "spacing",
        displayName: "Spacing",
        editor: "spacing",
        editorParams: {
          default: {
            marginTop: 100,
            marginRight: 0,
            marginLeft: 0,
            marginBottom: 0,
            paddingTop: 10,
            paddingRight: 10,
            paddingLeft: 10,
            paddingBottom: 10,
          },
          styleName: true,
        },
        help: "",
      },
    ],
    events: [],
    cssStates: [],
    actions: [
      { displayName: "Toggle", name: "toggle", props: [] },
      { displayName: "Open", name: "open", props: [] },
      { displayName: "Close", name: "close", props: [] },
    ],
  },
  {
    name: "Floating",
    displayName: "Floating Row",
    type: "overlay",
    id: "Floating",
    image:
      "https://storage.googleapis.com/deft-cef16.appspot.com/icons/Frame%2012.svg",
    props: [
      {
        name: "left",
        displayName: "Left",
        editor: "number",
        editorParams: { default: 0 },
        help: "",
      },
      {
        name: "top",
        displayName: "Top",
        editor: "number",
        editorParams: { default: 0 },
        help: "",
      },
      {
        name: "right",
        displayName: "Right",
        editor: "number",
        editorParams: { default: "" },
        help: "",
      },
      {
        name: "bottom",
        displayName: "Bottom",
        editor: "number",
        editorParams: { default: "" },
        help: "",
      },
      {
        name: "backgroundColor",
        displayName: "Background Color",
        editor: "color",
        editorParams: { default: "#E0E0E0", styleName: true },
        help: "Background Color of this Row",
      },
      {
        name: "border",
        displayName: "Border",
        editor: "border",
        editorParams: {
          default: {
            borderTop: "0px solid #333",
            borderRight: "0px solid #333",
            borderLeft: "0px solid #333",
            borderBottom: "0px solid #333",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
          },
          styleName: true,
        },
        help: "",
      },
      {
        name: "boxShadow",
        displayName: "Shadow",
        editor: "shadow",
        editorParams: {
          default: "0px 0px 0px 0px rgba(0,0,0,0)",
          styleName: "boxShadow",
        },
        help: "",
      },
      {
        name: "size",
        displayName: "Sizing",
        editor: "size",
        editorParams: {
          default: {
            minWidth: 100,
            maxWidth: "",
            minHeight: 100,
            maxHeight: "",
          },
          styleName: true,
        },
        help: "",
      },

      {
        name: "justifyContent",
        displayName: "Horizontal Alignment",
        editor: "justifyContent",
        editorParams: { default: "flex-start", styleName: true },
        help: "",
      },
      {
        name: "alignItems",
        displayName: "Vertical Alignment",
        editor: "alignItems",
        editorParams: { default: "flex-start", styleName: true },
        help: "",
      },
      {
        name: "display",
        displayName: "This Element is visible",
        editor: "checkbox",
        editorParams: {
          default: "flex",
          true: "flex",
          false: "none",
          styleName: true,
        },
        help: "",
      },
      {
        name: "spacing",
        displayName: "Spacing",
        editor: "spacing",
        editorParams: {
          default: {
            marginTop: 0,
            marginRight: 0,
            marginLeft: 0,
            marginBottom: 0,
            paddingTop: 0,
            paddingRight: 0,
            paddingLeft: 0,
            paddingBottom: 0,
          },
          styleName: true,
        },
        help: "",
      },
    ],
    events: [
      {
        name: "onClick",
        displayName: "when clicked",
        params: [],
      },
    ],
    cssStates: ["hover"],
  },
  {
    name: "Column",
    displayName: "Column",
    id: "Column",
    type: "container",
    image:
      "https://storage.googleapis.com/deft-cef16.appspot.com/icons/Frame%2015-new.svg",
    props: [
      {
        name: "backgroundColor",
        displayName: "Background Color",
        editor: "color",
        editorParams: { default: "#f2f2f2", styleName: "backgroundColor" },
        help: "",
      },
      {
        name: "border",
        displayName: "Border",
        editor: "border",
        editorParams: {
          default: {
            borderTop: "0px solid #333",
            borderRight: "0px solid #333",
            borderLeft: "0px solid #333",
            borderBottom: "0px solid #333",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
          },
          styleName: "border",
        },
        help: "",
      },
      {
        name: "boxShadow",
        displayName: "Shadow",
        editor: "shadow",
        editorParams: {
          default: "0px 0px 0px 0px rgba(0,0,0,0)",
          styleName: "boxShadow",
        },
        help: "",
      },
      {
        name: "flexGrow",
        displayName: "Flex Grow",
        editor: "flexGrow",
        editorParams: { default: 1, styleName: "flexGrow" },
        help:
          "This is how large this element should be relative to the other elements in the same column of row",
      },
      {
        name: "size",
        displayName: "Sizing",
        editor: "size",
        editorParams: {
          default: { minWidth: 40, maxWidth: "", minHeight: 40, maxHeight: "" },
          styleName: true,
        },
        help: "",
      },
      {
        name: "justifyContent",
        displayName: "Vertical Alignment",
        editor: "justifyContent",
        editorParams: { default: "flex-start", styleName: true },
        help: "",
      },
      {
        name: "alignItems",
        displayName: "Horizontal Alignment",
        editor: "alignItems",
        editorParams: { default: "stretch", styleName: true },
        help: "",
      },
      {
        name: "display",
        displayName: "This Element is visible",
        editor: "checkbox",
        editorParams: {
          default: "flex",
          true: "flex",
          false: "none",
          styleName: true,
        },
        help: "",
      },
      {
        name: "spacing",
        displayName: "Spacing",
        editor: "spacing",
        editorParams: {
          default: {
            marginTop: 10,
            marginRight: 10,
            marginLeft: 10,
            marginBottom: 10,
            paddingTop: 10,
            paddingRight: 10,
            paddingLeft: 10,
            paddingBottom: 10,
          },
          styleName: true,
        },
        help: "",
      },
    ],
    events: [
      {
        name: "onClick",
        displayName: "This Column is clicked",
        params: [],
      },
    ],
    cssStates: ["hover"],
  },
  {
    name: "Input",
    displayName: "Input",
    type: "input",
    image:
      "https://storage.googleapis.com/deft-cef16.appspot.com/icons/Frame%2020.svg",
    props: [
      {
        name: "placeholder",
        displayName: "placeholder",
        editor: "text",
        editorParams: { default: ["edit.."] },
        help: "",
      },
      {
        name: "default",
        displayName: "Default Value",
        editor: "dynamicText",
        editorParams: { default: [""] },
        help: "",
      },
      {
        name: "format",
        displayName: "Input Format",
        editor: "inputFormat",
        editorParams: {
          default: {
            type: "Text",
            inputType: "Type",
            mask: null,
            name: "Text",
          },
        },
        help: "",
      },
      {
        name: "textStyle",
        displayName: "Text Style",
        editor: "textStyle",
        editorParams: {
          default: {
            fontFamily: "Roboto",
            fontSize: 16,
            textAlign: "left",
            fontWeight: "400",
            fontStyle: "normal",
            textDecoration: "none",
            color: "#333",
          },
          styleName: "font",
        },
        help: "",
      },
      {
        name: "backgroundColor",
        displayName: "Background Color",
        editor: "color",
        editorParams: {
          default: "white",
          styleName: "background-color",
        },
        help: "",
      },
      {
        name: "border",
        displayName: "Border",
        editor: "border",
        editorParams: {
          default: {
            borderTop: "1px solid #333",
            borderRight: "1px solid #333",
            borderLeft: "1px solid #333",
            borderBottom: "1px solid #333",
            borderTopLeftRadius: 3,
            borderTopRightRadius: 3,
            borderBottomLeftRadius: 3,
            borderBottomRightRadius: 3,
          },
          styleName: "border-radius",
        },
        help: "",
      },
      {
        name: "boxShadow",
        displayName: "Shadow",
        editor: "shadow",
        editorParams: {
          default: "0px 0px 0px 0px rgba(0,0,0,0)",
          styleName: "boxShadow",
        },
        help: "",
      },

      {
        name: "size",
        displayName: "Sizing",
        editor: "size",
        editorParams: {
          default: { minWidth: "", maxWidth: "", minHeight: "", maxHeight: "" },
          styleName: "width",
        },
        help: "",
      },
      {
        name: "flexGrow",
        displayName: "Flex Grow",
        editor: "flexGrow",
        editorParams: { default: 0, styleName: "flex-grow" },
        help:
          "This is how large this element should be relative to the other elements in the same column of row",
      },
      {
        name: "spacing",
        displayName: "Spacing",
        editor: "spacing",
        editorParams: {
          default: {
            marginTop: 0,
            marginRight: 0,
            marginLeft: 0,
            marginBottom: 0,
            paddingTop: 8,
            paddingRight: 8,
            paddingLeft: 8,
            paddingBottom: 8,
          },
          styleName: "spacing",
        },
        help: "",
      },
    ],
    events: [
      {
        name: "onBlur",
        displayName: "This input is blured",
        params: [],
      },
      {
        name: "onKeypress",
        displayName: "Enter key is pressed",
        params: [],
      }
    ],
    stateVariables: [
      {
        value: "value",
        displayName: "Value",
        type: "",
        list: false,
        typeRef: "format.type",
      },
      {
        value: "focused",
        displayName: "is Focused",
        type: "True/False",
        list: false,
      },
    ],
    actions: [
      { name: "Clear", code: "clear", props: [] }
    ],
    cssStates: ["hover", "focus"],
  },
  {
    name: "Dropdown",
    displayName: "Dropdown",
    type: "input",
    image:
      "https://storage.googleapis.com/deft-cef16.appspot.com/icons/Frame%2023.svg",
    props: [
      {
        name: "_appType",
        displayName: "Datatype",
        editor: "appType",
        editorParams: {},
        help: "",
      },
      {
        name: "_display",
        displayName: "Display",
        editor: "dynamic",
        format: `(item) => ([[value]])`,
        editorParams: {
          type: "Text",
          list: false,
          sources: [
            {
              code: "item",
              name: "this item's",
              returnType: "_appType",
              returnList: false,
              params: [],
            },
          ],
        },
        help: "",
      },
      {
        name: "_data",
        displayName: "Data",
        editor: "dynamic",
        editorParams: {
          type: "_appType",
          list: true,
          default: [{}],
        },
        help: "",
      },
      {
        name: "default",
        displayName: "Default Value",
        editor: "dynamic",
        editorParams: { default: [{}], list: false, type: "_appType" },
        help: "",
      },
      {
        name: "textStyle",
        displayName: "Text Style",
        editor: "textStyle",
        editorParams: {
          default: {
            fontFamily: "Roboto",
            fontSize: 16,
            textAlign: "left",
            fontWeight: "400",
            fontStyle: "normal",
            textDecoration: "none",
            color: "#333",
          },
          styleName: "font",
        },
        help: "",
      },
      {
        name: "backgroundColor",
        displayName: "Background Color",
        editor: "color",
        editorParams: {
          default: "white",
          styleName: "background-color",
        },
        help: "",
      },
      {
        name: "border",
        displayName: "Border",
        editor: "border",
        editorParams: {
          default: {
            borderTop: "1px solid #333",
            borderRight: "1px solid #333",
            borderLeft: "1px solid #333",
            borderBottom: "1px solid #333",
            borderTopLeftRadius: 3,
            borderTopRightRadius: 3,
            borderBottomLeftRadius: 3,
            borderBottomRightRadius: 3,
          },
          styleName: "border-radius",
        },
        help: "",
      },
      {
        name: "boxShadow",
        displayName: "Shadow",
        editor: "shadow",
        editorParams: {
          default: "0px 0px 0px 0px rgba(0,0,0,0)",
          styleName: "boxShadow",
        },
        help: "",
      },

      {
        name: "size",
        displayName: "Sizing",
        editor: "size",
        editorParams: {
          default: { minWidth: "", maxWidth: "", minHeight: "", maxHeight: "" },
          styleName: "width",
        },
        help: "",
      },
      {
        name: "flexGrow",
        displayName: "Flex Grow",
        editor: "flexGrow",
        editorParams: { default: 0, styleName: "flex-grow" },
        help:
          "This is how large this element should be relative to the other elements in the same column of row",
      },
      {
        name: "spacing",
        displayName: "Spacing",
        editor: "spacing",
        editorParams: {
          default: {
            marginTop: 0,
            marginRight: 0,
            marginLeft: 0,
            marginBottom: 0,
            paddingTop: 8,
            paddingRight: 8,
            paddingLeft: 8,
            paddingBottom: 8,
          },
          styleName: "spacing",
        },
        help: "",
      },
    ],
    events: [
      {
        name: "onSelect",
        displayName: "A Value is Selected",
        params: [],
      },
    ],
    stateVariables: [
      {
        value: "value",
        displayName: "Value",
        type: "",
        list: false,
        typeRef: "_appType",
      },
    ],
    cssStates: ["focus"],
  },
  {
    name: "Textarea",
    displayName: "Text Area",
    type: "input",
    image:
      "https://storage.googleapis.com/deft-cef16.appspot.com/icons/Frame%2021.svg",
    props: [
      {
        name: "placeholder",
        displayName: "placeholder",
        editor: "text",
        editorParams: { default: ["edit.."] },
        help: "",
      },
      {
        name: "default",
        displayName: "Default Value",
        editor: "dynamicText",
        editorParams: { default: [""] },
        help: "",
      },
      {
        name: "textStyle",
        displayName: "Text Style",
        editor: "textStyle",
        editorParams: {
          default: {
            fontFamily: "Roboto",
            fontSize: 16,
            textAlign: "left",
            fontWeight: "400",
            fontStyle: "normal",
            textDecoration: "none",
            color: "#333",
          },
          styleName: "font",
        },
        help: "",
      },
      {
        name: "backgroundColor",
        displayName: "Background Color",
        editor: "color",
        editorParams: {
          default: "transparent",
          styleName: "background-color",
        },
        help: "",
      },
      {
        name: "border",
        displayName: "Border",
        editor: "border",
        editorParams: {
          default: {
            borderTop: "0px solid #333",
            borderRight: "0px solid #333",
            borderLeft: "0px solid #333",
            borderBottom: "0px solid #333",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
          },
          styleName: "border-radius",
        },
        help: "",
      },
      {
        name: "boxShadow",
        displayName: "Shadow",
        editor: "shadow",
        editorParams: {
          default: "0px 0px 0px 0px rgba(0,0,0,0)",
          styleName: "boxShadow",
        },
        help: "",
      },

      {
        name: "size",
        displayName: "Sizing",
        editor: "size",
        editorParams: {
          default: { minWidth: "", maxWidth: "", minHeight: "", maxHeight: "" },
          styleName: "width",
        },
        help: "",
      },
      {
        name: "flexGrow",
        displayName: "Flex Grow",
        editor: "flexGrow",
        editorParams: { default: 0, styleName: "flex-grow" },
        help:
          "This is how large this element should be relative to the other elements in the same column of row",
      },
      {
        name: "spacing",
        displayName: "Spacing",
        editor: "spacing",
        editorParams: {
          default: {
            marginTop: 0,
            marginRight: 0,
            marginLeft: 0,
            marginBottom: 0,
            paddingTop: 0,
            paddingRight: 0,
            paddingLeft: 0,
            paddingBottom: 0,
          },
          styleName: "spacing",
        },
        help: "",
      },
    ],
    events: [
      {
        name: "onBlur",
        displayName: "This input is blured",
        params: [],
      },
    ],
    stateVariables: [
      {
        value: "value",
        displayName: "Value",
        type: "Text",
        list: false,
      },
      {
        value: "focused",
        displayName: "is Focused",
        type: "True/False",
        list: false,
      },
    ],
    cssStates: ["hover", "focus"],
  },
  {
    name: "Text",
    displayName: "Text",
    type: "basic",
    image:
      "https://storage.googleapis.com/deft-cef16.appspot.com/icons/Frame%203.svg",
    props: [
      {
        name: "value",
        displayName: "Value",
        editor: "dynamicText",
        editorParams: { default: ["edit me..."], type: "Text", list: false },
        help: "",
      },
      {
        name: "textstyle",
        displayName: "Text Style",
        editor: "textStyle",
        editorParams: {
          default: {
            fontFamily: "Roboto",
            fontSize: 16,
            textAlign: "left",
            fontWeight: "400",
            fontStyle: "normal",
            textDecoration: "none",
            color: "#333",
          },
          styleName: "font",
        },
        help: "",
      },
      {
        name: "backgroundColor",
        displayName: "Background Color",
        editor: "color",
        editorParams: {
          default: "transparent",
          styleName: "background-color",
        },
        help: "",
      },
      {
        name: "border",
        displayName: "Border",
        editor: "border",
        editorParams: {
          default: {
            borderTop: "0px solid #333",
            borderRight: "0px solid #333",
            borderLeft: "0px solid #333",
            borderBottom: "0px solid #333",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
          },
          styleName: true,
        },
        help: "",
      },
      {
        name: "boxShadow",
        displayName: "Shadow",
        editor: "shadow",
        editorParams: {
          default: "0px 0px 0px 0px rgba(0,0,0,0)",
          styleName: "boxShadow",
        },
        help: "",
      },
      {
        name: "size",
        displayName: "Sizing",
        editor: "size",
        editorParams: {
          default: { minWidth: "", maxWidth: "", minHeight: "", maxHeight: "" },
          styleName: true,
        },
        help: "",
      },
      {
        name: "flexGrow",
        displayName: "Flex Grow",
        editor: "flexGrow",
        editorParams: { default: 0, styleName: "flex-grow" },
        help:
          "This is how large this element should be relative to the other elements in the same column of row",
      },
      {
        name: "visibility",
        displayName: "This Element is visible",
        editor: "checkbox",
        editorParams: {
          default: "visible",
          true: "visible",
          false: "hidden",
          styleName: true,
        },
        help: "",
      },
      {
        name: "display",
        displayName: "This Element is inline",
        editor: "checkbox",
        editorParams: {
          default: "block",
          true: "inline-block",
          false: "block",
          styleName: true,
        },
        help: "",
      },
      {
        name: "spacing",
        displayName: "Spacing",
        editor: "spacing",
        editorParams: {
          default: {
            marginTop: 0,
            marginRight: 0,
            marginLeft: 0,
            marginBottom: 0,
            paddingTop: 0,
            paddingRight: 0,
            paddingLeft: 0,
            paddingBottom: 0,
          },
          styleName: "min/max",
        },
        help: "",
      },
    ],
    events: [
      {
        name: "onClick",
        displayName: "When clicked",
        params: [],
      },
    ],
    cssStates: ["hover", "focused"],
  },
  {
    name: "Button",
    displayName: "Button",
    type: "basic",
    image:
      "https://storage.googleapis.com/deft-cef16.appspot.com/icons/Frame%202.svg",
    props: [
      {
        name: "value",
        displayName: "Text Value",
        editor: "text",
        editorParams: { default: ["Click Me"], type: "Text", list: false },
        help: "",
      },
      {
        name: "textstyle",
        displayName: "Text Style",
        editor: "textStyle",
        editorParams: {
          default: {
            fontFamily: "Roboto",
            fontSize: 16,
            textAlign: "center",
            fontWeight: "600",
            fontStyle: "normal",
            textDecoration: "none",
            color: "#fff",
          },
          styleName: "font",
        },
        help: "",
      },
      {
        name: "backgroundColor",
        displayName: "Background Color",
        editor: "color",
        editorParams: {
          default: "#2980b9",
          styleName: "background-color",
        },
        help: "",
      },
      {
        name: "border",
        displayName: "Border",
        editor: "border",
        editorParams: {
          default: {
            borderTop: "0px solid #333",
            borderRight: "0px solid #333",
            borderLeft: "0px solid #333",
            borderBottom: "0px solid #333",
            borderTopLeftRadius: 5,
            borderTopRightRadius: 5,
            borderBottomLeftRadius: 5,
            borderBottomRightRadius: 5,
          },
          styleName: true,
        },
        help: "",
      },
      {
        name: "boxShadow",
        displayName: "Shadow",
        editor: "shadow",
        editorParams: {
          default: "0px 0px 0px 0px rgba(0,0,0,0)",
          styleName: "boxShadow",
        },
        help: "",
      },

      {
        name: "size",
        displayName: "Sizing",
        editor: "size",
        editorParams: {
          default: { minWidth: "", maxWidth: "", minHeight: "", maxHeight: "" },
          styleName: true,
        },
        help: "",
      },
      {
        name: "flexGrow",
        displayName: "Flex Grow",
        editor: "flexGrow",
        editorParams: { default: 0, styleName: "flex-grow" },
        help:
          "This is how large this element should be relative to the other elements in the same column of row",
      },
      {
        name: "spacing",
        displayName: "Spacing",
        editor: "spacing",
        editorParams: {
          default: {
            marginTop: 0,
            marginRight: 0,
            marginLeft: 0,
            marginBottom: 0,
            paddingTop: 8,
            paddingRight: 8,
            paddingLeft: 8,
            paddingBottom: 8,
          },
          styleName: "min/max",
        },
        help: "",
      },
    ],
    events: [
      {
        name: "onClick",
        displayName: "When clicked",
        params: [],
      },
    ],
    cssStates: ["hover", "active"],
  },
  {
    name: "Icon",
    displayName: "Icon",
    type: "basic",
    image:
      "https://storage.googleapis.com/deft-cef16.appspot.com/icons/Frame%205.svg",
    props: [
      {
        name: "icon",
        displayName: "Icon",
        editor: "icon",
        editorParams: { default: "MdFace" },
        help: "",
      },
      {
        name: "iconSize",
        displayName: "Size",
        editor: "number",
        editorParams: { default: 24 },
        help: "",
      },
      {
        name: "color",
        displayName: "color",
        editor: "color",
        editorParams: {
          default: "#333",
          styleName: "color",
        },
        help: "",
      },

      {
        name: "backgroundColor",
        displayName: "Background Color",
        editor: "color",
        editorParams: {
          default: "rgba(0,0,0,0)",
          styleName: "background-color",
        },
        help: "",
      },
      {
        name: "border",
        displayName: "Border",
        editor: "border",
        editorParams: {
          default: {
            borderTop: "0px solid #333",
            borderRight: "0px solid #333",
            borderLeft: "0px solid #333",
            borderBottom: "0px solid #333",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
          },
          styleName: true,
        },
        help: "",
      },
      {
        name: "boxShadow",
        displayName: "Shadow",
        editor: "shadow",
        editorParams: {
          default: "0px 0px 0px 0px rgba(0,0,0,0)",
          styleName: "boxShadow",
        },
        help: "",
      },

      {
        name: "size",
        displayName: "Sizing",
        editor: "size",
        editorParams: {
          default: { minWidth: "", maxWidth: "", minHeight: "", maxHeight: "" },
          styleName: true,
        },
        help: "",
      },
      {
        name: "flexGrow",
        displayName: "Flex Grow",
        editor: "flexGrow",
        editorParams: { default: 0, styleName: "flex-grow" },
        help:
          "This is how large this element should be relative to the other elements in the same column of row",
      },
      {
        name: "spacing",
        displayName: "Spacing",
        editor: "spacing",
        editorParams: {
          default: {
            marginTop: 0,
            marginRight: 0,
            marginLeft: 0,
            marginBottom: 0,
            paddingTop: 0,
            paddingRight: 0,
            paddingLeft: 0,
            paddingBottom: 0,
          },
          styleName: "spacing",
        },
        help: "",
      },
    ],
    events: [
      {
        name: "onClick",
        displayName: "when clicked",
        params: [],
      },
    ],
  },
  {
    name: "Map",
    displayName: "Map",
    type: "basic",
    image:
      "https://storage.googleapis.com/deft-cef16.appspot.com/icons/Frame%206.svg",
    props: [
      {
        name: "location",
        displayName: "Pin Location(s)",
        editor: "dynamic",
        editorParams: {
          default: [{}],
          type: "Location",
          list: false,
        },
        help: "",
      },
      {
        name: "mapType",
        displayName: "Map Type",
        editor: "dropdown",
        editorParams: {
          default: "roadmap",
          options: [
            { text: "roadmap", value: "roadmap" },
            { text: "satellite", value: "satellite" },
            { text: "hybrid", value: "hybrid" },
            { text: "terrain", value: "terrain" },
          ],
        },
        help: "",
      },
      {
        name: "_appType",
        displayName: "Data Type for Markers",
        editor: "appType",
        editorParams: {},
        help: "",
      },

      {
        name: "border",
        displayName: "Border",
        editor: "border",
        editorParams: {
          default: {
            borderTop: "0px solid #333",
            borderRight: "0px solid #333",
            borderLeft: "0px solid #333",
            borderBottom: "0px solid #333",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
          },
          styleName: true,
        },
        help: "",
      },
      {
        name: "boxShadow",
        displayName: "Shadow",
        editor: "shadow",
        editorParams: {
          default: "0px 0px 0px 0px rgba(0,0,0,0)",
          styleName: "boxShadow",
        },
        help: "",
      },

      {
        name: "size",
        displayName: "Sizing",
        editor: "size",
        editorParams: {
          default: {
            minWidth: 200,
            maxWidth: "",
            minHeight: 200,
            maxHeight: "",
          },
          styleName: true,
        },
        help: "",
      },
      {
        name: "flexGrow",
        displayName: "Flex Grow",
        editor: "flexGrow",
        editorParams: { default: 0, styleName: "flex-grow" },
        help:
          "This is how large this element should be relative to the other elements in the same column of row",
      },
      {
        name: "spacing",
        displayName: "Spacing",
        editor: "spacing",
        editorParams: {
          default: {
            marginTop: 0,
            marginRight: 0,
            marginLeft: 0,
            marginBottom: 0,
            paddingTop: 0,
            paddingRight: 0,
            paddingLeft: 0,
            paddingBottom: 0,
          },
          styleName: "min/max",
        },
        help: "",
      },
    ],
    events: [],
  },
  {
    name: "Image",
    displayName: "Image",
    id: "Image",
    type: "basic",
    image:
      "https://storage.googleapis.com/deft-cef16.appspot.com/icons/Frame%204.svg",
    props: [
      {
        name: "image",
        displayName: "Image",
        editor: "image",
        editorParams: { default: "" },
        help: "",
      },
      {
        name: "backgroundSize",
        displayName: "Image Size",
        editor: "dropdown",
        editorParams: {
          default: "cover",
          options: [
            { text: "Cover", value: "cover" },
            { text: "Contain", value: "contain" },
          ],
          styleName: true,
        },
        help: "",
      },
      {
        name: "backgroundColor",
        displayName: "Background Color",
        editor: "color",
        editorParams: { default: "#e5e5e5", styleName: true },
        help: "",
      },
      {
        name: "border",
        displayName: "Border",
        editor: "border",
        editorParams: {
          default: {
            borderTop: "0px solid #333",
            borderRight: "0px solid #333",
            borderLeft: "0px solid #333",
            borderBottom: "0px solid #333",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
          },
          styleName: true,
        },
        help: "",
      },
      {
        name: "boxShadow",
        displayName: "Shadow",
        editor: "shadow",
        editorParams: {
          default: "0px 0px 0px 0px rgba(0,0,0,0)",
          styleName: "boxShadow",
        },
        help: "",
      },

      {
        name: "size",
        displayName: "Sizing",
        editor: "size",
        editorParams: {
          default: {
            minWidth: 200,
            maxWidth: "",
            minHeight: 200,
            maxHeight: "",
          },
          styleName: true,
        },
        help: "",
      },
      {
        name: "flexGrow",
        displayName: "Flex Grow",
        editor: "flexGrow",
        editorParams: { default: 1, styleName: true },
        help:
          "This is how large this element should be relative to the other elements in the same column of row",
      },
      {
        name: "display",
        displayName: "This Element is visible",
        editor: "checkbox",
        editorParams: {
          default: "block",
          true: "block",
          false: "none",
          styleName: true,
        },
        help: "",
      },
      {
        name: "spacing",
        displayName: "Spacing",
        editor: "spacing",
        editorParams: {
          default: {
            marginTop: 0,
            marginRight: 0,
            marginLeft: 0,
            marginBottom: 0,
            paddingTop: 0,
            paddingRight: 0,
            paddingLeft: 0,
            paddingBottom: 0,
          },
          styleName: true,
        },
        help: "",
      },
    ],
    events: [],
  },
  {
    name: "List",
    displayName: "List",
    type: "container",
    id: "List",
    image:
      "https://storage.googleapis.com/deft-cef16.appspot.com/icons/Frame%209.svg",
    props: [
      {
        name: "_appType",
        displayName: "Data Type for List",
        editor: "appType",
        editorParams: {},
        help: "",
        required: true,
      },
      {
        name: "data",
        displayName: "Data",
        editor: "dynamicData",
        editorParams: { type: "_appType", list: true },
        help: "",
        required: true,
      },
      {
        name: "backgroundColor",
        displayName: "Background Color",
        editor: "color",
        editorParams: { default: "#E0E0E0" },
        help: "Background Color of this Row",
      },
      {
        name: "border",
        displayName: "Border",
        editor: "border",
        editorParams: {
          default: {
            borderTop: "0px solid #333",
            borderRight: "0px solid #333",
            borderLeft: "0px solid #333",
            borderBottom: "0px solid #333",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
          },
        },
        help: "",
      },
      {
        name: "size",
        displayName: "Sizing",
        editor: "size",
        editorParams: {
          default: { minWidth: 40, maxWidth: "", minHeight: 40, maxHeight: "" },
          styleName: true,
        },
        help: "",
      },
      {
        name: "flexGrow",
        displayName: "Flex Grow",
        editor: "flexGrow",
        editorParams: { default: 1 },
        help:
          "This is how large this element should be relative to the other elements in the same column of row",
      },
    ],
    sources: [
      {
        name: "rowItem",
        displayName: "This rows [_appType]",
        type: "_appType",
        list: false,
      },
      {
        name: "index",
        displayName: "index",
        type: "Number",
        list: false,
      },
    ],
    events: [],
  },
  {
    name: "Grid",
    displayName: "Grid",
    type: "container",
    id: "Grid",
    image:
      "https://storage.googleapis.com/deft-cef16.appspot.com/icons/Frame%2011.svg",
    props: [
      {
        name: "_appType",
        displayName: "Data Type for Grid",
        editor: "appType",
        editorParams: {},
        help: "",
      },
      {
        name: "data",
        displayName: "Data",
        editor: "dynamicData",
        editorParams: { type: "_appType", list: true },
        help: "",
      },
      {
        name: "rows",
        displayName: "Rows",
        editor: "number",
        editorParams: { default: 3 },
        help: "",
      },
      {
        name: "backgroundColor",
        displayName: "Background Color",
        editor: "color",
        editorParams: { default: "#E0E0E0" },
        help: "Background Color of this Row",
      },
      {
        name: "border",
        displayName: "Border",
        editor: "border",
        editorParams: {
          default: {
            borderTop: "0px solid #333",
            borderRight: "0px solid #333",
            borderLeft: "0px solid #333",
            borderBottom: "0px solid #333",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
          },
        },
        help: "",
      },
      {
        name: "size",
        displayName: "Sizing",
        editor: "size",
        editorParams: {
          default: { minWidth: 40, maxWidth: "", minHeight: 40, maxHeight: "" },
          styleName: true,
        },
        help: "",
      },
      {
        name: "flexGrow",
        displayName: "Flex Grow",
        editor: "flexGrow",
        editorParams: { default: 1 },
        help:
          "This is how large this element should be relative to the other elements in the same column of row",
      },
    ],
    sources: [
      {
        name: "rowItem",
        displayName: "This rows [_appType]",
        type: "_appType",
        list: false,
      },
      {
        name: "index",
        displayName: "index",
        type: "Number",
        list: false,
      },
    ],
    events: [],
  },
  {
    name: "Fileupload",
    displayName: "File Uploader",
    type: "input",
    id: "FileUpload",
    image:
      "https://storage.googleapis.com/deft-cef16.appspot.com/icons/Frame%2025.svg",
    props: [
      {
        name: "placeholder",
        displayName: "placeholder",
        editor: "text",
        editorParams: { default: ["Click to upload"] },
        help: "",
      },
      {
        name: "default",
        displayName: "Default Value",
        editor: "dynamic",
        editorParams: { type: "Text", list: false },
        help: "",
      },
      {
        name: "accept",
        displayName: "Accept",
        editor: "dropdown",
        editorParams: {
          default: "*",
          options: [
            { value: "*", text: "All files" },
            { value: ".pdf,.doc,.docx,.txt", text: "PDF / Text Documents" },
            { value: "image/*", text: "Images" },
            { value: "video/*", text: "Videos" },
            { value: "audio/*", text: "Audio" },
          ],
        },
        help: "Choose what types of files the user can upload"
      },
      {
        name: "textStyle",
        displayName: "Text Style",
        editor: "textStyle",
        editorParams: {
          default: {
            fontFamily: "Roboto",
            fontSize: 16,
            textAlign: "center",
            fontWeight: "400",
            fontStyle: "normal",
            textDecoration: "none",
            color: "#333",
          },
          styleName: "font",
        },
        help: "",
      },
      {
        name: "backgroundColor",
        displayName: "Background Color",
        editor: "color",
        editorParams: {
          default: "white",
          styleName: "background-color",
        },
        help: "",
      },
      {
        name: "border",
        displayName: "Border",
        editor: "border",
        editorParams: {
          default: {
            borderTop: "1px solid #333",
            borderRight: "1px solid #333",
            borderLeft: "1px solid #333",
            borderBottom: "1px solid #333",
            borderTopLeftRadius: 5,
            borderTopRightRadius: 5,
            borderBottomLeftRadius: 5,
            borderBottomRightRadius: 5,
          },
          styleName: "border-radius",
        },
        help: "",
      },
      {
        name: "boxShadow",
        displayName: "Shadow",
        editor: "shadow",
        editorParams: {
          default: "0px 0px 0px 0px rgba(0,0,0,0)",
          styleName: "boxShadow",
        },
        help: "",
      },
      {
        name: "size",
        displayName: "Sizing",
        editor: "size",
        editorParams: {
          default: { minWidth: "", maxWidth: "", minHeight: "", maxHeight: "" },
          styleName: "width",
        },
        help: "",
      },
      {
        name: "flexGrow",
        displayName: "Flex Grow",
        editor: "flexGrow",
        editorParams: { default: 0, styleName: "flex-grow" },
        help:
          "This is how large this element should be relative to the other elements in the same column of row",
      },
      {
        name: "display",
        displayName: "This Element is visible",
        editor: "checkbox",
        editorParams: {
          default: "block",
          true: "block",
          false: "none",
          styleName: true,
        },
        help: "",
      },
      {
        name: "spacing",
        displayName: "Spacing",
        editor: "spacing",
        editorParams: {
          default: {
            marginTop: 0,
            marginRight: 0,
            marginLeft: 0,
            marginBottom: 0,
            paddingTop: 10,
            paddingRight: 10,
            paddingLeft: 10,
            paddingBottom: 10,
          },
          styleName: "spacing",
        },
        help: "",
      },
    ],
    events: [
      {
        name: "onSubmit",
        displayName: "This File is submitted",
        params: [
          {
            name: "value",
            displayName: "Value",
            editor: "dynamicText",
            editorParams: { default: ["edit me..."], type: "Text", list: false },
            help: "",
          },
        ],
      },
    ],
    stateVariables: [
      {
        value: "value",
        displayName: "Value",
        type: "File",
        list: false,
      },
      {
        value: "uploading",
        displayName: "is Uploading",
        type: "True/False",
        list: false,
      },
    ],
  },
];

export default blocks;
